"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAll = getAll;
async function getAll(productRepo, page = 1, pageSize = 10, productName) {
    return await productRepo.getAll(page, pageSize, productName);
}
